import 'core-js/es/string/starts-with';
import 'core-js/es/symbol';
import 'core-js/es/array/from';
import 'core-js/es/typed-array/slice';
import 'core-js/es/array/includes';
import 'core-js/es/string/includes';
import 'core-js/es/set';
import 'promise-polyfill/src/polyfill';
import 'fast-text-encoding';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';

import AuthClient from './AuthClient';
import { AuthClientOptions } from './global';

import './global';

export * from './global';

export default async function createAuthClient(options: AuthClientOptions) {
  const auth = new AuthClient(options);
  await auth.checkSession();
  return auth;
}

export { AuthClient };

export {
  GenericError,
  AuthenticationError,
  TimeoutError,
  PopupTimeoutError,
  PopupCancelledError,
  MfaRequiredError
} from './errors';

export { ICache, LocalStorageCache, InMemoryCache, Cacheable, SessionStorageCache } from './cache';
